module.exports = __webpack_public_path__ + "static/media/qr.4344c685.jpg";